import { type SiteLocation, type StationBrand, OrderMethods } from '@centric-os/types';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useSiteConfigStore } from '../../../routes/stores';

export default (siteLocation: Partial<SiteLocation>) => {
  const siteConfigStore = useSiteConfigStore();
  const { sitePublicConfig } = storeToRefs(siteConfigStore);

  // CF-674 moved the source of truth from the global cognition document to each
  // site's own public config.
  const isSiteFrictionless = computed<boolean>(() => {
    return Boolean(sitePublicConfig.value?.jwo?.enabled);
  });

  const initialValues = computed<Partial<StationBrand>>(() => {
    return {
      location: siteLocation?.id ?? '',
      name: '',
      label: {
        en: '',
      },
      location_description: '',
      orderMethod: undefined,
    };
  });

  const mapStation = (station: Partial<StationBrand>): Partial<StationBrand> => {
    const payload: Partial<StationBrand> = {
      location: station.location,
      name: station.name,
      label: {
        en: station.name,
      },
      location_description: station.location_description,
    };

    if (station.orderMethod) {
      payload.is = payload.is ?? {};
      switch (station.orderMethod) {
        case OrderMethods.PRE_ORDER:
          payload.is.scan_and_go_supported = false;
          payload.is.frictionless_supported = false;
          break;
        case OrderMethods.SCAN_N_PAY:
          payload.is.scan_and_go_supported = true;
          payload.is.frictionless_supported = false;
          break;
        case OrderMethods.JWO:
          payload.is.scan_and_go_supported = false;
          payload.is.frictionless_supported = isSiteFrictionless.value;
          payload.is.pickup_supported = isSiteFrictionless.value;
          break;
      }
    }

    return payload;
  };

  return { initialValues, mapStation };
};
